import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { DocumentAnalyzer, SearchVAT } from '@components';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const UtiltiesTabs = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="VAT Finder" {...a11yProps(0)} />
          <Tab label="Document Analyzer" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <SearchVAT />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DocumentAnalyzer />
      </TabPanel>
    </Box>
  );
};

const memoizedUtiltiesTabs = React.memo(UtiltiesTabs);
export { memoizedUtiltiesTabs as UtiltiesTabs };
